// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-upload .v-input__prepend-outer {\n  display: none !important;\n}\n.error-state {\n  border: 1px solid var(--v-error-base);\n  border-radius: 4px;\n}", ""]);
// Exports
module.exports = exports;
